
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/azure-functions",
      function () {
        return require("private-next-pages/destinations/azure-functions.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/azure-functions"])
      });
    }
  